import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import { GET_ALL_PROPERTY_BY_CLIENT_ID, LINK_QR_CODES } from "../api/apiPath";
import http from "../api/server";
// import { hostName } from "../config/config";
import Header from "./Header";
import Sidebar from "./Sidebar";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import useGetClientId from "../hooks/useGetClientId";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRefNo } from "../store/slices/refNoSlice";

export default function LinkQRcode() {
  //   const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("new");
  const [newDoorProperty, setNewDoorProperty] = useState("");
  const [existingDoorProperty, setExistingDoorProperty] = useState("");
  const [allPropertyList, setAllPropertyList] = useState(null);
  const clientObj = useGetClientId();
  const location = useLocation();
  const dispatch = useDispatch();
  const styles = {
    tabContainer: {
      display: "flex",
      borderBottom: "1px solid #3a4a66",
      marginBottom: "30px",
    },
    tabButton: (isActive) => ({
      padding: "10px 24px",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: 500,
      color: isActive ? "#ff6b35" : "#ccc",
      borderBottom: isActive ? "2px solid #ff6b35" : "2px solid transparent",
      background: "none",
      outline: "none",
    }),

    button: {
      backgroundColor: "#c54a2b",
      color: "white",
      border: "none",
      borderRadius: "6px",
      padding: "10px 24px",
      fontSize: "15px",
      cursor: "pointer",
      marginTop: "25px",
    },
    buttonHover: {
      backgroundColor: "#a83f25",
    },
  };

  const handleGetAllPropertyByClinetID = async (clientObj) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientObj?.clientId
      );
      if (response.status === 200) {
        response?.data?.forEach((item) => {
          item.id = item.propertyMasterId;
        });
        setAllPropertyList(response.data);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    const refNo = queryParams.get("refNo");
    try {
      const response = await http.get(LINK_QR_CODES + "?refNo=" + refNo);

      if (response.status === 204) {
        console.log("Request successful, but no content returned.");
      } else if (response.status === 200) {
        const fullUrl = response?.data;
        if (fullUrl) {
          try {
            // ✅ Safely extract pathname using the URL constructor
            const path = fullUrl.split(".uk")[1] || "/"; // "/client/tanjiro/dashboard"
            navigate(path);
          } catch (err) {
            console.error("Invalid URL:", err);
          }
        }

        console.log("Data received:", response.data);
      } else {
        console.log("Unexpected response:", response.status);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const handleNewDoorPropertyChange = (e) => {
    const selectedProperty = e.target.value;
    setNewDoorProperty(selectedProperty);
    console.log("Selected country:", selectedProperty);
  };
  const handleExistingDoorPropertyChange = (e) => {
    const selectedProperty = e.target.value;
    setExistingDoorProperty(selectedProperty);
    console.log("Selected country:", selectedProperty);
  };
  useEffect(() => {
    if (clientObj) {
      handleGetAllPropertyByClinetID(clientObj);
    }
  }, [clientObj.clientId, clientObj.loading]);
  useEffect(() => {
    if (userObj) {
      fetchData(userObj);
    }
  }, [userObj]);

  const saveQRCodeRefNoInRedux = () => {
    const queryParams = new URLSearchParams(location.search);
    const refNo = queryParams.get("refNo");

    if (refNo) {
      dispatch(setRefNo(refNo));
      console.log("✅ Saved refNo in Redux:", refNo);
    } else {
      console.warn("⚠️ refNo not found in URL");
    }
  };

  const handleSaveNewDoor = () => {
    saveQRCodeRefNoInRedux();
  };

  const handleSaveExistingDoor = () => {
    saveQRCodeRefNoInRedux();
  };

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          {/* Tabs */}
          <div
            className=" dashboard_body  py-0 w-100"
            style={{ marginLeft: "10px", marginTop: "25px" }}
          >
            <div
              className="col-sm-12 d-flex align-items-center"
              style={{ marginBottom: "20px" }}
            >
              <div className="col-sm-6">
                <div className="text-start">
                  <p className="fs-3 fw-bold m-0">Link QRCodes with Doors</p>
                </div>
              </div>
            </div>
            {/* <div>Link QR code with Door</div> */}
            <div style={styles.tabContainer} className="col-12 col-md-12">
              <button
                style={styles.tabButton(activeTab === "new")}
                onClick={() => setActiveTab("new")}
                className="col-6 col-md-6"
              >
                New Door
              </button>
              <button
                style={styles.tabButton(activeTab === "existing")}
                onClick={() => setActiveTab("existing")}
                className="col-6 col-md-6"
              >
                Existing Door
              </button>
            </div>

            {/* Tab Content */}
            {activeTab === "new" ? (
              <>
                <div>
                  <select
                    className="form-select form-control"
                    value={newDoorProperty}
                    onChange={(e) => handleNewDoorPropertyChange(e)}
                  >
                    <option>Property Name</option>y
                    {console.log("allPropertyList", allPropertyList)}
                    {allPropertyList?.map((data, index) => (
                      <option key={index} value={data.propertyName}>
                        {data.propertyName}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    style={styles.button}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#a83f25")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c54a2b")
                    }
                    onClick={() => {
                      handleSaveNewDoor();
                    }}
                  >
                    Continue
                  </button>
                </div>
              </>
            ) : (
              <>
                <div
                  className="col-12 col-md-12"
                  style={{ marginBottom: "20px" }}
                >
                  <select
                    className="form-select form-control"
                    value={existingDoorProperty}
                    onChange={(e) => handleExistingDoorPropertyChange(e)}
                  >
                    <option>Property Name</option>
                    {allPropertyList?.map((data, index) => (
                      <option key={index} value={data.propertyName}>
                        {data.propertyName}
                      </option>
                    ))}
                  </select>
                </div>
                <div
                  className="col-12 col-md-12"
                >
                  <select
                    className="form-select form-control"
                    value={""}
                    onChange={() => console.log("")}
                  >
                    <option>Door Refrance Number</option>
                    {/* {[
                        ...new Set(
                          completedSurveyData.map((user) => user.propertyName)
                        ),
                      ].map((propertyName, index) => (
                        <option key={index} value={propertyName}>
                          {propertyName}
                        </option>
                      ))} */}
                  </select>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    style={styles.button}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#a83f25")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c54a2b")
                    }
                    onClick={() => {
                      handleSaveExistingDoor();
                    }}
                  >
                    Continue
                  </button>
                </div>
              </>
            )}
          </div>
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
      <LoadingComponent loading={loading} />
    </>
  );
}
